import http from "../../../request";

export default {
  // all: async (context) => {
  //   let response = await http.get("art_works", `${localStorage.getItem("lang")}&page=${context.state.page}`);
  //   context.commit("setWorks", response.data);
  //   context.commit("setMeta", response.meta);
  //   if (context.state.meta) {
  //     if (context.state.meta.total > context.state.page) {
  //       context.commit("increasePage");
  //     } else {
  //       context.commit("allWorksLoaded", true);
  //     }
  //   }
  // },
  resetWorks: (context) => {
    context.commit("reset");
  },
  filterWorks: async (context, payload) => {
    if (!context.state.allWorksLoaded) {
      context.commit("noResult", false);

      let response = await http.get(
        `art_works/filter/${payload.type}/${payload.year}`,
        `${localStorage.getItem("lang")}&page=${context.state.page}`
      );
      context.commit("setWorks", response.data);
      if(response.data.length == 0){
        context.commit("noResult", true);
      }
      context.commit("setMeta", response.meta);
      if (context.state.meta) {
        if (context.state.meta.last_page > context.state.page) {
          context.commit("increasePage");
        } else {
          context.commit("allWorksLoaded", true);
        }
      }
    }
  },
  resetWorkDetails: (context) => {
    context.commit("resetWorkDetails");
  },
  getWork: async (context, payload) => {
    let response = await http.get(
      `art_works/${payload}`,
      localStorage.getItem("lang")
    );
    context.commit("setWork", response);
  },
};
